<form @submit.prevent="search" class="vl-form aeg-u-bg-alt aeg-u-box-padding">
    <div class="aeg-u-bg-white aeg-u-box-padding">
        <vl-form-grid mod-stacked>
            <vl-column width-l="7">
                <label for="transaction-id">Transaction Id</label>
                <vl-input-field id="transaction-id" name="transaction-id" v-model="transactionId" autocomplete="off" mod-block/>
            </vl-column>
            <vl-column width-l="5">
                <vl-form-grid mod-stacked>
                    <vl-column width="6">
                        <label for="date-from">Van</label>
                        <vl-datepicker visual-format="d/m/Y H:i" v-model="dateFrom" enable-time id="date-from"/>
                    </vl-column>
                    <vl-column width="6">
                        <label for="date-to">Tot en met</label>
                        <vl-datepicker visual-format="d/m/Y H:i" v-model="dateTo" enable-time id="date-to"/>
                    </vl-column>
                </vl-form-grid>
            </vl-column>
            <vl-column width="3">
                <label for="status">Status <aeg-session-status-popover/> </label>
                <vl-select id="status" name="status" mod-no-placeholder mod-block v-model="selectedState">
                    <option v-for="opt in sessionStateOptions" :key="String(opt.value)" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </vl-select>
            </vl-column>
            <vl-column width="3">
                <label for="session-type">Soort sessie</label>
                <vl-select id="session-type" name="session-type" mod-no-placeholder mod-block v-model="selectedSessionType">
                    <option v-for="opt in sessionTypeOptions" :key="String(opt.value)" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </vl-select>
            </vl-column>
            <vl-column width="3">
                <label for="paymentMethod">Betaalmethode</label>
                <vl-select id="paymentMethod" name="paymentMethod" mod-no-placeholder mod-block v-model="selectedPaymentMethod">
                    <option v-for="opt in paymentMethodOptions" :key="String(opt.value)" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </vl-select>
            </vl-column>
            <vl-column width="3">
                <label for="service-type">Service</label>
                <vl-select id="service-type" name="service-type" mod-no-placeholder mod-block v-model="selectedServiceType">
                    <option v-for="opt in serviceTypeOptions" :key="String(opt.value)" :value="opt.value">
                        {{ opt.label.toUpperCase() }}
                    </option>
                </vl-select>
            </vl-column>
            <vl-column width="6">
                <label for="actor-identifier">Identificator (KBO, OVO, OrgCode of SubjectId)</label>
                <vl-input-field name="actor-identifier" id="actor-identifier" v-model="actorIdentifier" autocomplete="off" mod-block/>
            </vl-column>
            <vl-column width="6">
                <label for="actor">Actor</label>
                <vl-input-field name="actor" id="actor" v-model="actorName" autocomplete="off" mod-block/>
            </vl-column>
            <vl-column width="6">
                <label for="sessionDetail">Sessiedetails</label>
                <vl-input-field name="sessionDetail" id="sessionDetail" v-model="sessionDetail" autocomplete="off" mod-block/>
            </vl-column> 
            <vl-column width="6">
                <label for="documentNumber">Documentnummer</label>
                <vl-input-field name="documentNumber" id="documentNumber" v-model="documentNumber" autocomplete="off" mod-block/>
            </vl-column>
        </vl-form-grid>
    </div>
</form>